export default __webpack_public_path__ + "static/media/exghands.f8f63412.png";